<template>
  <div class="page-err">
    <img @click="goBack" class="error-page-image" :src="IMG404" alt="404-image" />
    <el-button class="btn" size="medium" type="danger" @click="goBack">返回</el-button>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Page404 extends Vue {
  IMG404 = require('@/assets/404.png')

  goBack() {
    this.$router.go(-1)
  }
}
</script>

<style lang="scss" scoped>
  .page-err {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .error-page-image {
      width: 400px;
      height: auto;
    }

    .btn {
      margin-top: 20px;
    }
  }
</style>
